import React, { useState, useRef } from 'react';

import { useQuery } from '@tanstack/react-query';

import Button from '../../../Button';
import Player from './Player';

import FreshcallerCallService from '../../../../services/FreshcallerCallService';

export default function CallRecording({ call }) {
  const [shouldPlay, setShouldPlay] = useState(false);

  const buttonRef = useRef();

  const { recording } = call.call_data;

  const { data: recordingUrl } = useQuery({
    queryKey: ['callRecording', call.call_data.id, recording?.id],
    queryFn: () =>
      FreshcallerCallService.getFreshcallerCallRecording({
        callId: call.call_data.id,
        recordingId: recording.id,
      }),
    enabled: shouldPlay,
  });

  if (!recording) {
    return null;
  }

  return (
    <div className="relative">
      <Button
        variant="tetriary"
        className="h-6"
        onClick={() => setShouldPlay((prevState) => !prevState)}
        reference={buttonRef}
      >
        {shouldPlay ? 'Close' : 'Play'}
      </Button>
      {shouldPlay && recordingUrl && (
        <Player
          recordingUrl={recordingUrl}
          close={() => setShouldPlay(false)}
          buttonRef={buttonRef}
        />
      )}
    </div>
  );
}
